import Navbar from 'emerald-ui/lib/Navbar';
import Nav from 'emerald-ui/lib/Nav';
import Avatar from 'emerald-ui/lib/Avatar';
import DropdownButton from 'emerald-ui/lib/DropdownButton';
import DropdownItem from 'emerald-ui/lib/DropdownItem';
import Icon from 'emerald-ui/lib/Icon';
import Container from 'emerald-ui/lib/Container';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Navbar, componentName: 'Navbar' }], 'Navbar'),
  description: `A Navbar serves as navigation for the app or site.`,
  codeSamples: [
    {
      title: 'Default',
      scope: {
        Avatar,
        DropdownButton,
        DropdownItem,
        Icon,
        Nav,
        Navbar,
      },
      code: `<Navbar breakAt="lg">
  <Navbar.Brand>
    <h2 style={{ margin: 0 }}>
      <a href="#foo">
        Emerald
      </a>
    </h2>
  </Navbar.Brand>
  <Nav grow collapsible>
    <a href="#foo">Link 1</a>
    <a href="#foo">Link 2</a>
    <a href="#foo">Link 3</a>
    <DropdownButton title="Dropdown" id="dd1">
      <DropdownItem eventKey="1">Action</DropdownItem>
      <DropdownItem eventKey="2">Another action</DropdownItem>
      <DropdownItem eventKey="3" active>
        Active Item
      </DropdownItem>
      <DropdownItem separator />
      <DropdownItem eventKey="4">Separated link</DropdownItem>
    </DropdownButton>
  </Nav>
  <Nav collapsible>
    <a href="#foo">
      <Icon name="email" />
    </a>
    <DropdownButton
      noCaret
      fromRight
      id="dd2"
      title={<Avatar title="JS" />}
    >
      <DropdownItem eventKey="1">Action</DropdownItem>
      <DropdownItem eventKey="2">Another action</DropdownItem>
      <DropdownItem eventKey="3" active>
        Active Item
      </DropdownItem>
      <DropdownItem separator />
      <DropdownItem eventKey="4">Separated link</DropdownItem>
    </DropdownButton>
  </Nav>
</Navbar>`,
    },
    {
      title: 'With Container inside',
      scope: {
        Avatar,
        DropdownButton,
        DropdownItem,
        Icon,
        Nav,
        Navbar,
        Container,
      },
      code: `<Navbar breakAt="lg">
  <Container>
    <Navbar.Brand>
      <h2 style={{ margin: 0 }}>
        <a href="#foo">
          Emerald
        </a>
      </h2>
    </Navbar.Brand>
    <Nav grow collapsible>
      <a href="#foo">Link 1</a>
      <a href="#foo">Link 2</a>
      <a href="#foo">Link 3</a>
      <DropdownButton title="Dropdown" id="dd1">
        <DropdownItem eventKey="1">Action</DropdownItem>
        <DropdownItem eventKey="2">Another action</DropdownItem>
        <DropdownItem eventKey="3" active>
          Active Item
        </DropdownItem>
        <DropdownItem separator />
        <DropdownItem eventKey="4">Separated link</DropdownItem>
      </DropdownButton>
    </Nav>
    <Nav collapsible>
      <a href="#foo">
        <Icon name="email" />
      </a>
      <DropdownButton
        noCaret
        fromRight
        id="dd2"
        title={<Avatar title="JS" />}
      >
        <DropdownItem eventKey="1">Action</DropdownItem>
        <DropdownItem eventKey="2">Another action</DropdownItem>
        <DropdownItem eventKey="3" active>
          Active Item
        </DropdownItem>
        <DropdownItem separator />
        <DropdownItem eventKey="4">Separated link</DropdownItem>
      </DropdownButton>
    </Nav>
  </Container>
</Navbar>`,
    },
  ],
};
